module.exports = __webpack_public_path__ + "img/bg-feedback-rating.6c03ae1e.png";